/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MeterInfoHardwareRequest
 */
export interface MeterInfoHardwareRequest {
    /**
     * 
     * @type {string}
     * @memberof MeterInfoHardwareRequest
     */
    'scope': MeterInfoHardwareRequestScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoHardwareRequest
     */
    'councilCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoHardwareRequest
     */
    'model': string;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoHardwareRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof MeterInfoHardwareRequest
     */
    'brandAdminPortalId': number;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoHardwareRequest
     */
    'brandCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoHardwareRequest
     */
    'type'?: MeterInfoHardwareRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeterInfoHardwareRequest
     */
    'variant'?: MeterInfoHardwareRequestVariantEnum;
}

export const MeterInfoHardwareRequestScopeEnum = {
    Global: 'GLOBAL',
    Council: 'COUNCIL'
} as const;

export type MeterInfoHardwareRequestScopeEnum = typeof MeterInfoHardwareRequestScopeEnum[keyof typeof MeterInfoHardwareRequestScopeEnum];
export const MeterInfoHardwareRequestTypeEnum = {
    SmartMeter: 'SMART_METER',
    DataLogger: 'DATA_LOGGER',
    Unknown: 'UNKNOWN'
} as const;

export type MeterInfoHardwareRequestTypeEnum = typeof MeterInfoHardwareRequestTypeEnum[keyof typeof MeterInfoHardwareRequestTypeEnum];
export const MeterInfoHardwareRequestVariantEnum = {
    Water: 'WATER',
    Gas: 'GAS',
    Electricity: 'ELECTRICITY',
    Unknown: 'UNKNOWN'
} as const;

export type MeterInfoHardwareRequestVariantEnum = typeof MeterInfoHardwareRequestVariantEnum[keyof typeof MeterInfoHardwareRequestVariantEnum];


